import React from 'react';
import PropTypes from 'prop-types';

const Transition = ({ className, children }) => (
  <div className={className}>
    {children}
  </div>
);

Transition.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

Transition.defaultProps = {
  className: '',
};

export default Transition;
